/* eslint-disable no-loop-func */
import React, { useCallback, useEffect, useState } from 'react';

import classNames from 'classnames';

import type { Dayjs } from 'dayjs';

import { TbArrowLeft, TbArrowRight } from 'react-icons/tb';

import Icon from 'components-new/icon/icon';

import Typography from 'components/typography/typography';

import type { FreelancerAvailability } from 'state/__generated__/tadaahAPI';

import { getCalendarCellsData } from 'utils/availability-calendar';

import type { CalendarCell } from 'utils/availability-calendar';

import { DAYS, MONTHS } from 'constants/calendar';

interface AvailabilityCalendarPropTypes {
  fromDate: Dayjs;
  toDate?: Dayjs;
  AvailabilityList?: FreelancerAvailability[];
  weekdays?: number[];
}

const AvailabilityCalendar: React.FC<AvailabilityCalendarPropTypes> = (
  props,
) => {
  const { fromDate, toDate, weekdays, AvailabilityList } = props;
  const [currentDate, setCurrentDate] = useState(fromDate);
  const [calendarCells, setCalendarCells] = useState<CalendarCell[]>([]);

  const getNextMonth = useCallback(() => {
    const nextMonth = currentDate.add(1, 'month');
    if (
      (toDate && toDate.isAfter(nextMonth)) ||
      (toDate?.get('year') === nextMonth.get('year') &&
        toDate.get('month') === nextMonth.get('month'))
    ) {
      setCurrentDate((prev) => prev.add(1, 'month'));
      setCalendarCells([
        ...getCalendarCellsData(
          fromDate,
          currentDate.add(1, 'month'),
          toDate,
          weekdays || [],
          AvailabilityList || [],
        ),
      ]);
    }
  }, [currentDate, toDate, fromDate, weekdays, AvailabilityList]);

  const getPerviousMonth = useCallback(() => {
    const perviousMonth = currentDate.add(-1, 'month');
    if (
      (fromDate && fromDate.isBefore(perviousMonth)) ||
      (fromDate?.get('year') === perviousMonth.get('year') &&
        fromDate.get('month') === perviousMonth.get('month'))
    ) {
      setCurrentDate((prev) => prev.add(-1, 'month'));
      setCalendarCells([
        ...getCalendarCellsData(
          fromDate,
          currentDate.add(-1, 'month'),
          toDate,
          weekdays || [],
          AvailabilityList || [],
        ),
      ]);
    }
  }, [currentDate, AvailabilityList, fromDate, toDate, weekdays]);

  useEffect(() => {
    // if (currentDate === fromDate)
    setCalendarCells(
      getCalendarCellsData(
        fromDate,
        currentDate,
        toDate,
        weekdays || [],
        AvailabilityList || [],
      ),
    );
  }, [AvailabilityList, currentDate, fromDate, toDate, weekdays]);

  const getCurrentMonth = useCallback(() => {
    return ` ${MONTHS[currentDate.month()]} ${currentDate.year()}`;
  }, [currentDate]);
  return (
    <>
      <div className="flex flex-col w-[236px] h-[266px] items-start justify-center">
        <div className="flex items-center justify-between w-full h-6 mb-4 ">
          <Icon
            icon={TbArrowLeft}
            className={classNames(
              'cursor-pointer',
              currentDate.month() === fromDate?.month()
                ? 'text-gray-200'
                : 'text-gray400',
            )}
            onClick={getPerviousMonth}
          />
          <Typography
            as="h3"
            variant="body-large-bold"
            className="text-gray-800"
          >
            {getCurrentMonth()}
          </Typography>
          <Icon
            icon={TbArrowRight}
            className={classNames(
              'mr-1 cursor-pointer',
              currentDate.month() === toDate?.month()
                ? 'text-gray-200'
                : 'text-gray400',
            )}
            onClick={getNextMonth}
          />
        </div>
        <div className="grid grid-cols-7  gap-1 w-[100%]">
          {DAYS.map((val) => (
            <Typography
              key={val}
              as="p"
              variant="body-small-bold"
              className="h-4 w-7 mb-2 text-center flex items-center justify-center text-gray-500"
            >
              {val}
            </Typography>
          ))}
          {calendarCells.map((cell) => (
            <Typography
              as="p"
              variant="body-small"
              key={`${cell.weekday} ${cell.date}`}
              className={classNames(
                'p-2 h-7 w-7 rounded-md text-center flex items-center justify-center',
                cell.className,
              )}
            >
              {cell.date.date()}
            </Typography>
          ))}
        </div>
      </div>
    </>
  );
};

export default AvailabilityCalendar;
